var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-split-a",
    d: "m2.667 8 .94.94 3.726-3.72v8.113h1.334V5.22l3.72 3.727.946-.947L8 2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-split-c",
    d: "M0 0h33.333v33.333H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeOpacity: "var(--svg-bg-opacity)",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 27,
    x: 10,
    y: 4,
    fill: "currentColor",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 5,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 17,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 29,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 41,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 53,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 65,
    y: 33,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 9.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-screen-split-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-split-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-share-screen-split-b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-split-c",
    fill: "var(--svg-arrow-color)",
    transform: "translate(-8.667 -8.667)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenSplit);
export default __webpack_public_path__ + "static/media/share-screen-split.0392aef67bb654a2b27a7646f4edcb57.svg";
export { ForwardRef as ReactComponent };